import { configureStore, combineReducers } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { getDefaultMiddleware } from '@reduxjs/toolkit';

import storage from "redux-persist/lib/storage";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

store.subscribe(() => {
  const state = store.getState();

  const persist = {
    user: state.user,
  };

  if (window.ReactNativeWebView) {
    const response = {
      type: 'state',
      data: persist
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(response));
  }
});

export const persistor = persistStore(store);